import { connect } from 'react-redux';
import { changePhone as _changePhone } from '../../actions/phoneAuth';
import { resetToUsernameAuth as _resetToUsernameAuth } from '../../actions/state';
import { hasPhoneErrorSelector, isPhoneAuthFormSubmitting, isPhoneInvalidSelector, phoneErrorSelector, phoneSelector } from './selectors';
import { PhoneAuthFormContainer as Component } from './PhoneAuthFormContainer';
import { applyPhone } from '../../actions/phoneAuth/applyPhone';

function mapStateToProps(state) {
  return {
    isSubmitting: isPhoneAuthFormSubmitting(state),
    phone: phoneSelector(state),
    hasAsyncPhoneError: hasPhoneErrorSelector(state),
    isPhoneInvalid: isPhoneInvalidSelector(state),
    phoneError: phoneErrorSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePhone: function changePhone(phone) {
      dispatch(_changePhone(phone));
    },
    onSubmit: function onSubmit() {
      dispatch(applyPhone());
    },
    resetToUsernameAuth: function resetToUsernameAuth() {
      dispatch(_resetToUsernameAuth());
    }
  };
}

export var PhoneAuthFormContainer = connect(mapStateToProps, mapDispatchToProps)(Component);